import { Container, Sprite } from 'pixi.js';
import { createBitmapText, scaleToFit } from '../../Utils/Utils';
import { UIButton } from '../Shared/Buttons/UIButton';
import { HudActions, HudEmitter } from '../../Managers/Hud/HudEmitter';
import { Popup } from '../../Managers/Popups';
import { AdContexts, AdGameAreas, AdRewardTypes } from '../../DeltaTracking/AdParamBuilder';
import Core from '../../Core/Core';

export default class HeartDisplay extends Container {
    public icon: Sprite;
    private currencyText: PIXI.extras.BitmapText;
    private timeText: PIXI.extras.BitmapText;
    private addBtn: UIButton;
    private maxValue: number;

    constructor(maxVal: number) {
        super();

        let bgId = 'mapui/tophud-bg-slot01';
        // we can add this if we get landscape slot backgrounds that match the size of the others
        /* if(Core.orientation === GameOrientation.LANDSCAPE) {
            bgId = bgId + "-landscape";
        } */
        const bg = new Sprite(PIXI.utils.TextureCache[bgId]);
        bg.anchor.set(0.5);

        const icon = new Sprite(PIXI.utils.TextureCache['mapui/tophud-icon-heart']);
        icon.anchor.set(0.5);
        icon.x = -(bg.width * 0.38);

        this.currencyText = createBitmapText(
            '000',
            new PIXI.Rectangle(0, 0, icon.width * 0.7, icon.height * 0.5),
            'font'
        );
        this.currencyText.anchor = 0.5;
        this.currencyText.x = icon.x;
        this.currencyText.y = icon.height * 0.5;

        this.timeText = createBitmapText(
            '00:00',
            new PIXI.Rectangle(0, 0, bg.width * 0.4, bg.height * 0.5),
            'font'
        );
        // this.timeText.anchor = 0.5;
        this.timeText.x = -(this.timeText.width * 0.48);
        this.timeText.y = -this.timeText.height * 0.5;

        const plusButton = new UIButton('mapui/button-buy');
        plusButton.x = bg.width * 0.5 - plusButton.width * 0.4;
        plusButton.on('trigger', () => {
            Core.delta.setAdParams(AdRewardTypes.LIFE, AdContexts.LIFE_NEEDED, AdGameAreas.MAP, -1);

            HudEmitter.instance.emit(HudActions.ADD_POPUP, Popup.CURRENCY, 0, 'heart');
        });

        //@ts-ignore
        this.addChild(bg, icon, this.currencyText, this.timeText, plusButton);
        this.addBtn = plusButton;
        this.icon = icon;
        this.maxValue = maxVal;
    }

    public showCurrencyValue(val: number) {
        if (this.addBtn) {
            this.addBtn.alpha = val >= this.maxValue ? 0 : 1;
            if (val >= this.maxValue) {
                this.addBtn.interactive = false;
            }
        }
        this.currencyText.scale.set(1);
        this.currencyText.text = val.toString(10);
        this.currencyText.scale.set(
            scaleToFit(
                this.currencyText.width,
                this.currencyText.height,
                this.icon.width * 0.7,
                this.icon.height * 0.5
            )
        );
        this.currencyText.x = this.icon.x;
        this.currencyText.y = this.icon.y + this.icon.height * 0.15;
    }

    public showHeartTime(timeLeft: string) {
        this.timeText.text = timeLeft;
        this.timeText.x =
            timeLeft === 'MAX' ? -(this.timeText.width * 0.3) : -(this.timeText.width * 0.48);
    }
}
